import { Component, ViewChild, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { Platform, ModalController } from '@ionic/angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Context, InjectedContext } from './shared/services/context.service';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { AuthService } from './auth/services/auth.service';
import { UserAuthentifie, Role } from './model/user';
import { SidebarComponent, MenuComponent } from '@syncfusion/ej2-angular-navigations';
import { Menu, MenuItemModel, MenuEventArgs } from '@syncfusion/ej2-navigations';
import { enableRipple } from '@syncfusion/ej2-base';
import { UserService } from './service/user.service';
import { CustomLoadingService } from './service/custom-loading.service';
// for load other langugage in scheudler 
import { loadCldr } from '@syncfusion/ej2-base';
import { GabaritService } from './service/gabaritOutil.service';
import { PatientsListComponent } from './components/patients-list/patients-list.component';
import { RecherchePatientModalComponent } from './components/recherche-patient-modal/recherche-patient-modal.component';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { dirname } from 'path';
import { UserStaffService } from './service/user-staff.service';
import { MessagingWebsocketService } from './service/messaging-websocket.service';
import { MessageNotificationService } from './service/message-notification.service';
import { ConversationService, ConversationResponse, ConversationMessageResponse } from './service/conversation.service';
import { StompSubscription } from '@stomp/stompjs';
import { TreatmentPlanNotification } from './model/treatment-plan-notification.model';
import { Subscription } from 'rxjs';
import { NotificationService, NotificationItem } from './service/notification.service';
import { filter } from 'rxjs/operators';

declare var require: any;
enableRipple(true);
loadCldr(
    require('cldr-data/supplemental/numberingSystems.json'),
    require('cldr-data/main/fr-CH/ca-gregorian.json'),
    require('cldr-data/main/fr-CH/numbers.json'),
    require('cldr-data/main/fr-CH/timeZoneNames.json'));


@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit {
    @ViewChild('menu', { static: true }) public menuObj: MenuComponent;
    @ViewChild('sidebarMenuInstance', { static: false }) public sidebarMenuInstance: SidebarComponent;

    public isDesktop;
    public currentUser: UserAuthentifie;

    public loading;
    public results = [];
    public isEmpty: boolean;

    public width: string = '300px';
    public mediaQuery: string = ('(min-width: 600px)');
    public target: string = '.main-content';
    public dockSize: string = '100px';
    public enableDock: boolean = true;
    public closeOnDocumentClick: boolean = true; // close sidebar when clicking content [closeOnDocumentClick]="closeOnDocumentClick"
    userName: string;
    totalUnreadMessages: number = 0;
    treatmentPlanUnread: number = 0;
    treatmentPlanNotifications: NotificationItem[] = []; // Changed type
    historicNotifications: NotificationItem[] = []; // Changed type
    showTreatmentNotificationsPanel: boolean = false;
    private globalUnreadByConversation: { [id: number]: number } = {};
    private globalWsSubscriptions: { [id: number]: StompSubscription } = {};
    private treatmentPlanSubscription: Subscription;
    private latestUnreadConversationId: number;
    idPatient: string;
    descriptionheader: string;
    ageonYear: number;
    patient: any;


    if(condition) {

    }

    public menuItems: MenuItemModel[] = [];
    public AccountMenuItem: MenuItemModel[] = [
        {
            text: 'Compte',
            items: [
                // { text: 'Profile' },
                { text: 'Se déconnecter' },
            ]
        }
    ];

    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private context: Context,
        private router: Router,
        private modalCtrl: ModalController,
        private authservice: AuthService,
        private userService: UserService,
        private customLoadingService: CustomLoadingService,
        private gabritService: GabaritService,
        private dataRoute: ActivatedRoute,
        private userStaffService: UserStaffService,
        private messagingWsService: MessagingWebsocketService,
        private messageNotificationService: MessageNotificationService,
        private conversationService: ConversationService,
        private notificationService: NotificationService
    ) {
        this.isDesktop = this.context.detectPlatformDesktop();
        this.menuItems;

        this.loadMenu();
        this.initContextVars();

        this.messageNotificationService.getTotalUnread().subscribe(count => {
            this.totalUnreadMessages = count;
        });
    }

    loadMenu() {
        let value = localStorage.getItem('currentUser');
        if (!value) {
            InjectedContext.Fromlogout = true;
        } else {
            InjectedContext.Fromlogout = false;
        }
    }

    check() {
        if (InjectedContext.Fromlogout) {
            return true;
        }
        return false;
    }

    async initializeApp() {
        // if(!this.isDesktop) {
        await this.platform.ready().then(() => {
            this.statusBar.styleLightContent();
            this.splashScreen.hide();
        });
        // }
    }

    async initContextVars() {

        if (this.authservice.isLogged()) {
            const result = Promise.all([
                await this.gabritService.getAllGabarit().toPromise(),
                await this.userService.getSmall('').toPromise(),
            ]);
            result.then(async result => {
                InjectedContext.GabaritOutils = result[0];
                InjectedContext.listPraticien = result[1];
                await this.initializeApp();
                // ensure websocket connection is opened when user is logged in
                this.messagingWsService.connect()
                    .then(() => {
                        this.initGlobalMessageNotifications();

                        // Initialize NotificationService subscriptions
                        this.notificationService.notificationCount$.subscribe(count => {
                            this.treatmentPlanUnread = count;
                        });

                        this.notificationService.notifications$.subscribe(notifications => {
                            // Split into "new" (unread) and "historic" (read) for display
                            this.treatmentPlanNotifications = notifications.filter(n => !n.isRead);
                            this.historicNotifications = notifications.filter(n => n.isRead);
                        });
                    })
                    .catch(() => { });
            });
        } else if (localStorage.getItem('ACCESS_TOKEN') != null) {
            this.router.navigateByUrl('/home');
        } else {
            this.logout();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            let url = window.location.href.split('/');
            let itemSelected = document.getElementById(url[url.length - 1]);
            if (itemSelected) {
                itemSelected.setAttribute('style', 'background: #eff6ff !important; border-left: 3px solid #3b82f6 !important; pointer-events: none;');
            }
        }, 1000);
    }

    async logout() {
        this.customLoadingService.presentLoading().then(async value => {
            this.authservice.logout().then(async x => {
                this.customLoadingService.dismissLoading();
                // ensure websocket connection is closed on logout
                this.messagingWsService.disconnect();
                this.globalUnreadByConversation = {};
                this.globalWsSubscriptions = {};
                this.messageNotificationService.setTotalUnread(0);
                this.treatmentPlanUnread = 0;
                if (this.treatmentPlanSubscription) {
                    this.treatmentPlanSubscription.unsubscribe();
                    this.treatmentPlanSubscription = null;
                }
                this.treatmentPlanNotifications = [];
                this.showTreatmentNotificationsPanel = false;
                await this.initializeApp(); // hide splach
            });
        });
    }

    public currentUserValue() {
        var value = localStorage.getItem('currentUser');
        this.currentUser = JSON.parse(value);
        // console.log(this.currentUser);
        var name = this.currentUser.firstname + ' ' + this.currentUser.lastname;
        return name;
    }

    private initGlobalMessageNotifications() {
        // load current conversations and initial unread counts
        this.conversationService.getConversations().subscribe(convs => {
            this.globalUnreadByConversation = {};
            for (let i = 0; i < convs.length; i++) {
                const c: ConversationResponse = convs[i];
                this.globalUnreadByConversation[c.id] = c.unreadCount || 0;
                this.subscribeGlobalConversation(c.id);
            }
            this.recalculateGlobalUnread();
        }, () => {
            // ignore errors, badge will stay at 0
        });
    }

    private subscribeGlobalConversation(conversationId: number) {
        if (!conversationId || this.globalWsSubscriptions[conversationId]) {
            return;
        }
        const sub = this.messagingWsService.subscribeToConversation(conversationId);
        this.globalWsSubscriptions[conversationId] = sub.subscription;

        if (sub.messages$) {
            sub.messages$.subscribe((msg: ConversationMessageResponse) => {
                if (!msg || !msg.conversationId) {
                    return;
                }
                const cid = msg.conversationId;
                let count = (msg.unreadCount !== undefined && msg.unreadCount !== null)
                    ? msg.unreadCount
                    : (this.globalUnreadByConversation[cid] || 0) + 1;
                this.globalUnreadByConversation[cid] = count;
                this.recalculateGlobalUnread();

                // Track latest unread conversation
                if (count > 0) {
                    this.latestUnreadConversationId = cid;
                }
            });
        }
    }

    private recalculateGlobalUnread() {
        let total = 0;
        for (const key in this.globalUnreadByConversation) {
            if (this.globalUnreadByConversation.hasOwnProperty(key)) {
                const val = this.globalUnreadByConversation[key];
                if (val && val > 0) {
                    total++; // Count conversations, not messages
                }
            }
        }
        this.messageNotificationService.setTotalUnread(total);
    }

    // Old notification methods removed - handled by NotificationService

    openTreatmentNotifications(event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        this.showTreatmentNotificationsPanel = !this.showTreatmentNotificationsPanel;
    }

    closeTreatmentNotificationsPanel() {
        this.showTreatmentNotificationsPanel = false;
    }

    getNotificationMessage(notif: NotificationItem): string {
        if (notif.message) {
            return notif.message;
        }

        switch (notif.event) {
            case 'CREATED':
                return `Nouveau plan de traitement créé${notif.typePDT ? ' (' + notif.typePDT + ')' : ''}`;
            case 'STATUS_CHANGED':
                const statusLabels: { [key: string]: string } = {
                    'RECU': 'Reçu',
                    'ANNULER': 'Annulé',
                    'EN_COURS': 'En cours',
                    'EXPEDIER': 'Expédié'
                };
                const statusLabel = statusLabels[notif.status] || notif.status;
                return `Statut modifié: ${statusLabel}`;
            case 'COMMENT_UPDATED':
                if (notif.commentaire) {
                    const preview = notif.commentaire.length > 60
                        ? notif.commentaire.substring(0, 60) + '...'
                        : notif.commentaire;
                    return `Commentaire: ${preview}`;
                }
                return 'Commentaire mis à jour';
            default:
                return 'Notification de plan de traitement';
        }
    }

    formatNotificationDate(timestamp: number): string {
        if (!timestamp) {
            return '';
        }
        try {
            const date = new Date(timestamp);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}`;
        } catch (e) {
            return '';
        }
    }

    handleNotificationClick(event: Event, notif: NotificationItem, isNew: boolean) {
        event.stopPropagation();
        console.log('Notification clicked:', notif);

        // Optimistic update via service
        if (!notif.isRead) {
            this.notificationService.markAsReadLocal(notif);

            // Sync with backend
            if (notif.id) {
                this.notificationService.markAsRead(notif.id).subscribe();
            }
        }

        // Navigation for both new and historic
        if (notif.metaId) {
            console.log('Navigating to plan:', notif.metaId);
            this.router.navigate(['/plan-de-traitement'], {
                queryParams: {
                    view: 'suivis',
                    highlightId: notif.metaId
                }
            });
            this.closeTreatmentNotificationsPanel();
        } else {
            console.warn('No metaId found in notification, cannot redirect:', notif);
        }
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        // Close notification panel if clicking outside
        if (this.showTreatmentNotificationsPanel) {
            const target = event.target as HTMLElement;
            const notificationIcon = target.closest('ion-icon[name="notifications"]');
            const isClickOnNotificationIcon = notificationIcon && notificationIcon.closest('li');
            if (!target.closest('.notification-panel') && !isClickOnNotificationIcon) {
                this.closeTreatmentNotificationsPanel();
            }
        }
    }

    get isQuestionnaire() {
        var value = localStorage.getItem('currentUser');
        this.currentUser = JSON.parse(value);
        if (this.currentUser) {
            return ((this.currentUser.authorities[0].name) == Role.Questionnaire);
        }
        return false;
    }

    get isAdmin() {
        var value = localStorage.getItem('currentUser');
        if (value && value != 'undefined') {
            this.currentUser = JSON.parse(value);
            if (this.currentUser.authorities.length > 0) {
                return ((this.currentUser.authorities[0].name) == Role.Admin);
            }
            return false;
        } else {
            return false;
        }
    }

    // open new tab
    newTabClick(): void {
        let URL = location.href.replace(location.search, '');
        document.getElementById('newTab').setAttribute('href', URL.split('#')[0] + 'sidebar/sidebar-menu');
    }

    onSearchChange(searchValue: string) {
        return this.userService.searchEntries(searchValue)
            .subscribe(results => {
                this.results = results;
                this.isEmpty = false;
                if (results.length === 0) {
                    this.isEmpty = true;
                }
            });
    }

    async select(args: MenuEventArgs): Promise<void> {
        if (args.item.id == 'photos-list' && !localStorage.getItem('idPatient')) {
            this.search(args);
        } else if (args.item.id == 'fiche-patient' && !localStorage.getItem('idPatient')) {
            this.search(args);
        } else if (args.item.id == 'basdiag' && !localStorage.getItem('idPatient')) {
            this.search(args);
        } else if (args.item.id == 'choix-bas-diag-mini' && !localStorage.getItem('idPatient')) {
            this.search(args);
        } else if ((args.item.id == 'choix-bas-diag' || args.item.text == 'BASDIAG FULL') && !localStorage.getItem('idPatient')) {
            this.search(args);
            this.hideSidebar();
        } else if (args.item.id == 'choix-bas-diag' || args.item.text == 'BASDIAG FULL') {
            this.hideSidebar();
            this.changeBackgroundSelectedItem(args.item.id);
            this.router.navigate(['/' + args.item.id], { replaceUrl: true });
        } else if (args.item.id == 'cephalometrie' && !localStorage.getItem('idPatient')) {
            // localStorage.setItem("idPatient", '0');
            this.search(args)
        }
        else if (args.item.id == 'search' || args.item.id == 'recherche-patient') {
            await this.openRecherchePatientModal();
        }

        else if (!args.item.items || args.item.items.length == 0) {
            this.changeBackgroundSelectedItem(args.item.id);
            this.router.navigate(['/' + args.item.id], { replaceUrl: true });
        }



    }

    hideSidebar(): void {
        if (this.sidebarMenuInstance) {
            this.sidebarMenuInstance.hide();
        }
    }

    selectAccount(args: MenuEventArgs): void {
        if (args.item.text == 'Se déconnecter') {
            this.logout();
        }
    }

    resizeMenu() {
        this.ngAfterViewInit(); // for select first item after login
        if (this.router.url != '/adult-sheet') {
            this.sidebarMenuInstance.toggle();
        }
    }

    created() {
        let removedItems: string[] = ['Contrôle Image'];
        let itemsForAdmin: string[] = ['Statistiques'];
        // let itemsForQues: string[] = ['Q1CS'];

        // if (!this.isDesktop) this.menuObj.removeItems(removedItems, false);
        // if (!this.isAdmin) this.menuObj.removeItems(itemsForAdmin, false);
        // if (!this.isQuestionnaire) this.menuObj.removeItems(itemsForQues, false);

    }

    onCreated(args: any) {
        //  if( this.isDesktop)
        //  this.resizeMenu();
        //  else {
        this.resizeMenu();
        this.resizeMenu();
        //  }
    }

    

    SuperAdmin(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name == 'ROLE_SUPER_ADMIN') {
                return true
            }
        }
    }

    Admin(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name == 'ROLE_ADMIN') {
                return true
            }
        }
    }

    Rh(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name == 'ROLE_RH') {
                return true
            }
        }
    }

    Praticien(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name == 'ROLE_PRATICIEN') {
                return true
            }
        }
    }

    ASSISTANTE(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name == 'ROLE_ASSISTANTES') {
                return true
            }
        }
    }

    Secretaire(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name == 'ROLE_SECRETAIRES') {
                return true
            }
        }
    }

    USER(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name == 'ROLE_USER') {
                return true
            }
        }
    }

    Financier(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].name == 'ROLE_FINANCIERS') {
                return true
            }
        }
    }


    profile() {
        this.router.navigate(['/my-profile'], { replaceUrl: true })
    }

    messagerie() {
        if (this.totalUnreadMessages > 0 && this.latestUnreadConversationId) {
            this.router.navigate(['/messagerie'], { queryParams: { conversationId: this.latestUnreadConversationId }, replaceUrl: true });
        } else {
            this.router.navigate(['/messagerie'], { replaceUrl: true });
        }
    }

    async openRecherchePatientModal() {
        const cssStyle = this.isDesktop ? 'my-custom-modal-isDesktop-css' : 'my-custom-modal-mobile-css';
        const modal = await this.modalCtrl.create({
            component: RecherchePatientModalComponent,
            cssClass: cssStyle,
            componentProps: {}
        });
        await modal.present();
    }

    searchIcone() {
        this.openRecherchePatientModal();
    }

    async search(args) {
        let cssStyle = 'my-custom-modal-isDesktop-css';
        if (!this.isDesktop) {
            cssStyle = 'my-custom-modal-mobile-css';
        }
        const modal = await this.modalCtrl.create({
            component: PatientsListComponent,
            cssClass: cssStyle,
            componentProps: {}
        });
        modal.onDidDismiss()
        this.router.navigate(['home']);
        console.log('args', args);

        if (args != undefined) {
            this.router.navigate(['/' + args.item.id], { replaceUrl: true })
        }

        else {
            this.router.navigate(['home']);
        }

        return modal.present();
    }



    calculAge(date): void {
        let olddate = date.toString().split("T")[0];
        let newDate = new Date(olddate);

        if (newDate != undefined) {
            var todayDate = new Date();
            var ageyear = todayDate.getFullYear() - newDate.getFullYear();
            var agemonth = todayDate.getMonth() - newDate.getMonth();
            var ageday = todayDate.getDate() - newDate.getDate();

            if (agemonth <= 0) {
                ageyear--;
                agemonth = 12 + agemonth;
            }
            if (todayDate.getDate() < newDate.getDate()) {
                agemonth--;
                ageday = 30 + ageday;
            }
            if (agemonth == 12) {
                ageyear = ageyear + 1;
                agemonth = 0;
            }
            this.ageonYear = ageyear;
            this.creatPatientResume()

        }
    }

    creatPatientResume() {

        if (this.patient.per_genre == "F") {
            var sexe = "FEMENIN"

        }
        else if (this.patient.per_genre == "M") {
            var sexe = "MASCULAIN"
        }

        if (this.ageonYear < 16) {
            var age = "ENFANT"

        }
        else {
            var age = "ADULTE"

        }


        this.descriptionheader = this.patient.per_prenom + " " + this.patient.per_nom + " " + " | " + this.ageonYear + " ANS" + " ";
    }

    getpersonneById(id) {
        this.userStaffService.GetPersonneById(id).toPromise().then(res => {
            this.patient = res;
            this.calculAge(this.patient.per_datnaiss)


        })
    }

    ngOnInit(): void {
        var value = localStorage.getItem('currentUser');
        this.idPatient = localStorage.getItem('idPatient');
        this.currentUser = JSON.parse(value);
        this.userName = "DR." + this.currentUser.firstname + " " + this.currentUser.lastname

        if (this.idPatient != null && this.idPatient != "") {
            this.getpersonneById(this.idPatient);
        }
        else {
            localStorage.setItem("idPatient", "");
        }

        var data = this.currentUser.authorities;
        this.menuItems = [];
        if (this.Admin(data) || this.Rh(data) || this.ASSISTANTE(data) || this.USER(data) || this.Praticien(data) || this.Secretaire(data) ||
        this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: "ACCUEIL",
                    iconCss: 'homme',
                    id: 'home',
                }
            )
        }

        if (this.Admin(data) || this.ASSISTANTE(data) || this.Praticien(data) || this.USER(data) ||
        this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'RECHERCHE PATIENTS',
                    iconCss: 'search',
                    id: 'recherche-patient',
                },

            )
        }

        if (this.Admin(data) || this.Rh(data) || this.ASSISTANTE(data) || this.USER(data) || this.Praticien(data) || this.Secretaire(data) || this.Financier(data) || this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'Fiche Patient',
                    iconCss: 'fichepatient',
                    id: 'fiche-patient'
                },

            )
        }


        if (this.Admin(data) || this.Rh(data) || this.ASSISTANTE(data) || this.USER(data) || this.Praticien(data) || this.Secretaire(data) ||
        this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'BAS NOUVEAU PATIENT',
                    iconCss: 'nvpatient',
                    id: 'baspremier',
                },

            )
        }


        if (this.Admin(data) || this.Rh(data) || this.ASSISTANTE(data) || this.USER(data) || this.Praticien(data) || this.Secretaire(data) || this.Financier(data) || this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'BAS PHOTO',
                    iconCss: 'basphoto',
                    id: 'photos-list'
                },

            )
        }

        if (this.Admin(data) || this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'BASDIAG FULL',
                    iconCss: 'diagadult',
                    id: 'choix-bas-diag',
                },

            )

        }
        if (this.Admin(data) ||
        this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'BASDIAG LITE',
                    iconCss: 'diagenfant',
                    id: 'choix-bas-diag-mini',
                },

            )

        }
        if (this.Admin(data) || this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'CÉPHALOMÉTRIE',
                    iconCss: 'cephalo',
                    id: 'cephalometrie',
                },

            )
        }

        if (this.Admin(data) || this.Rh(data) || this.ASSISTANTE(data) || this.USER(data) || this.Praticien(data) || this.Secretaire(data) || this.Financier(data) ||
        this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'Q1CS',
                    iconCss: 'q1cs',
                    id: 'q1cs',
                },

            )
        }


        if (this.Admin(data) || this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'Plan de traitement',
                    iconCss: 'traitement',
                    id: 'plan-de-traitement',
                },

            )

        }

        if ((this.Admin(data) || this.Rh(data) || this.ASSISTANTE(data) || this.USER(data) || this.Praticien(data) || this.Secretaire(data) || this.Financier(data) || this.SuperAdmin(data)) && this.isDesktop ){
            this.menuItems.push(
                {
                    text: 'Suivi des Appareils',
                    iconCss: 'suivi',
                    id: 'suivis-pdt',
                },
                   
            )
            
        }
        if (this.Admin(data) || this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'PARAMETRAGE',
                    iconCss: 'parametrage',
                    id: 'parametrage',
                },

            )
        }
        if (this.Admin(data) || this.USER(data) || this.SuperAdmin(data)) {
            this.menuItems.push(
                {
                    text: 'LISTE DES PATIENTS',
                    iconCss: 'listepatient',
                    id: 'liste-patients',
                },

            )
        }

        if (this.SuperAdmin(data)) {
        this.menuItems.push(
            {
            text: 'Gestion Des Comptes',
            iconCss: 'diagenfant',
            id: 'access',        
            }
        );
        }

        this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
            const segment = event.urlAfterRedirects.split('/')[1].split('?')[0];
            setTimeout(() => {
            try {
                this.changeBackgroundSelectedItem(segment);
            } catch (e) {}
            }, 300);
        }
        });

    }

    changeBackgroundSelectedItem(selectedItem) {
    let itemSelected = document.getElementById(selectedItem);
    let allItems = document.getElementById("sidebar-menu").getElementsByTagName("li");
    for (let i = 0; i < allItems.length; i++) {
        allItems[i].setAttribute("style", "background: #ffffff !important;"); 
    }
    itemSelected.setAttribute('style', 'background: #eff6ff !important; border-left: 3px solid #3b82f6 !important; pointer-events: none;');
    }
}

export function isWindows(): boolean {
    if (!window || !navigator) {
        return false;
    }

    const a: string = navigator.userAgent || navigator.vendor || (window as any).opera;

    return /windows/i.test(a);
}